<template>
  <div class="my-wrap finance-wrap">
    <div class="deposit-frame">
      <div class="my-deposit-frame">
        <div class="my-deposit my-d-box">
          <!-- 手機版流程-->
          <div class="my-deposit-package-mobile">
            <div class="mobile-frame">
              <div class="channel-text-n">
                {{ $t('Bao.deposit_select') }}
              </div>
              <!-- mb 上方選單 -->
              <div class="mobile-frame">
                <div class="mobile-wallet-card">
                  <div class="wallet-list-on">
                    {{ $t('Bao.deposit') }}
                  </div>
                  <div class="wallet-list" @click="$router.push('/withdrawal')">
                    {{ $t('Bao.withdraw_menu') }}
                  </div>
                  <div class="wallet-list" @click="$router.push('/user/wallet-history')">
                    {{ $t('Bao.transaction-index') }}
                  </div>
                </div>
                <div class="deposit-bg">
                  <div v-if="outerTypes && outerTypes.length > 0" class="bank-choice">
                    <div
                      v-if=" outerTypes[0].paymentMethods.length > 0"
                      class="bank-electron"
                      :class="{ active: selectedType === 1 }"
                      @click.stop="selectType(1)"
                    >
                      <p> {{ $t('Bao.channel_epay') }}</p>
                    </div>
                    <div
                      v-if=" outerTypes[1].paymentMethods.length > 0"
                      class="bank-bank"
                      :class="{ active: selectedType === 2}"
                      @click.stop="selectType(2)"
                    >
                      <p> {{ $t('Bao.channel_bank') }}</p>
                    </div>
                    <div
                      v-if=" outerTypes[2].paymentMethods.length > 0"
                      class="bank-bitcoin"
                      :class="{ active: selectedType === 3 }"
                      @click.stop="selectType(outerTypes[2].type)"
                    >
                      <p>{{ $t('Bao.channel_crypto') }}</p>
                    </div>
                    <div
                      v-if=" outerTypes[3].paymentMethods.length > 0"
                      class="bank-credit-card"
                      :class="{ active: selectedType === 4 }"
                      @click.stop="selectType(outerTypes[3].type)"
                    >
                      <p>{{ $t('Bao.credit_card') }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- mb 下半部 -->
              <div class="mobile-frame">
                <div
                  v-if="outerTypes && outerTypes.length > 0 && selectedType"
                  class="deposit-frame-n"
                >
                  <p>{{ $t('Bao.payment_select') }}</p>
                </div>

                <!-- mb 選擇存款方式 -->
                <div v-if="outerTypes && outerTypes.length > 0 && selectedType" class="channel-bank-frame">
                  <div
                    v-for="payment in outerTypes[selectedType - 1].paymentMethods"
                    :key="payment.payment_id"
                    class="channel-bank-card-n"
                    :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
                  >
                    <div v-if="payment.label && payment.label.length > 0" class="recommended-tags-frame">
                      <div v-if="payment.label[0]" class="recommended-tags red-bg">
                        {{ payment.label[0] }}
                      </div>
                      <div v-if="payment.label[1]" class="recommended-tags">
                        {{ payment.label[1] }}
                      </div>
                    </div>
                    <div
                      class="bank-choice-text grid-container"
                      @click.stop="selectPayment(payment, payment.name, payment.typeCode)"
                    >
                      <div class="icon-deposit">
                        <img :src="payment.image" alt="">
                      </div>
                      <div class="channel-describe-frame">
                        <p class="channel-name-n">
                          {{ payment.name }}
                        </p>
                        <p class="describe-n">
                          {{ $t('Bao.min_to_max') }}:
                          <span class="secondary">{{ payment.amount_limit.min }}-{{ payment.amount_limit.max }}</span>
                        </p>
                      </div>
                      <p class="fs-10px text-align-L flex-fill announcement">
                        {{ payment.announcement }}
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="selectedPayment && selectedPayment.typeNum !== 3 && (selectedPayment.typeCode !== 'PayPal' && selectedPayment.typeCode !== 'JetonCash'|| selectedPayment.code === 'HeroPay')" class="form-frame">
                  <div v-if="selectedPayment && selectedPayment.typeNum !== 3" class="input-amount-group">
                    <div class="form-input-n input-frame input-dep-amount-frame">
                      <div class="input-title">
                        {{ $t('Bao.amount') }}
                      </div>
                      <div class="input-amount">
                        <input
                          v-model="postForm.amount"
                          class="input-amount-content"
                          type="text"
                          placeholder="0"
                          @input="validateNumber"
                        >
                        <span class="currency">JPY</span>
                      </div>
                    </div>

                    <div class="amount-range-frame">
                      <ul class="slider-number">
                        <li
                          v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                          :key="key"
                          @click="handleAmount(price)"
                        >
                          {{ price | numberFormat }}
                        </li>
                      </ul>
                      <ul class="slider-dot">
                        <li
                          v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                          :key="key"
                          @click="handleAmount(price)"
                        >
                          <img :src="$getThemeImagePath('dot.svg')" alt="">
                        </li>
                      </ul>
                      <div class="slider-bar" />
                      <div
                        v-show="selectedAmount"
                        class="slider-bar og"
                        :style="{ width: percent + '%' }"
                      >
                        <img :src="$getThemeImagePath('dot-orange.svg')" alt="">
                      </div>
                    </div>
                  </div>

                  <!-- mb VegaWallet -->
                  <form v-if="selectedPayment && selectedPayment.name === 'VegaWallet'" class="dep-form-frame colu-12 ga-3">
                    <div class="colu colu-12">
                      <label class="colu-12 for-label" for="Vega Walletパスワード-mb">{{ $t('Bao.deposit_account') }}</label>
                      <input
                        id="Vega Walletパスワード-mb"
                        v-model="other.uid"
                        class="for-input"
                        type="text"
                        :placeholder="$t('Bao.deposit_account')"
                        @input="checkAccountErrors"
                      >
                      <div v-for="error in accountErrors" :key="error" class="input-feedback text-align-R">
                        {{ error }}
                      </div>
                    </div>

                    <div class="colu colu-12">
                      <label class="colu-12 for-label" for="Vega WalletユーザーID-mb">{{ $t('Bao.deposit_password') }}</label>
                      <input
                        id="Vega WalletユーザーID-mb"
                        v-model="other.password"
                        v-validate="'required'"
                        class="for-input"
                        type="password"
                        :placeholder="$t('Bao.deposit_password')"
                      >
                      <div v-if="errors.has('password')" class="input-feedback text-align-R">
                        {{ $t("Bao.deposit_password_error") }}
                      </div>
                    </div>
                  </form>

                  <!-- mb JetonPay -->
                  <form v-if="selectedPayment && selectedPayment.name === 'JetonPay'" class="dep-form-frame colu-12 ga-3">
                    <div class="colu colu-12">
                      <label class="colu-12 for-label">{{ $t('Bao.jeton_account') }}</label>
                      <input
                        id="Vega Walletパスワード-mb"
                        v-model="other.uid"
                        type="text"
                        :placeholder="$t('Bao.jeton_account')"
                        class="for-input"
                        @input="checkJetonErrors"
                      >
                      <div v-for="error in jetonErrors" :key="error" class="input-feedback text-align-R">
                        {{ error }}
                      </div>
                    </div>
                  </form>

                  <!-- mb PayPal -->
                  <div v-if="selectedPayment && selectedPayment.typeCode === 'PayPal'" class="fastDepositFrame">
                    <div class="FD-title text-center">
                      {{ $t('Bao.prize_select') }}
                    </div>
                    <div class="FD-amount-box">
                      <div
                        v-for="(price, key) in selectedPayment.price_list"
                        :key="key"
                        class="FD-amount-item"
                        :class="selectedAmount === price ? 'active' : ''"
                        @click="handleAmount(price)"
                      >
                        ¥{{ price }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- mb 加密貨幣 -->
                <crypto-detail v-if="isMobile() && selectedPayment && selectedPayment.typeNum === 3" :selected-payment="selectedPayment" class="form-frame" />

                <!-- mb JetonCash -->
                <div v-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'" class="form-frame">
                  <div class="crypto-select-frame">
                    <div class="colu-12 for-label">
                      {{ $t('Bao.currency') }}
                    </div>
                    <div class="lang-select">
                      <button class="btn-select" value="EUR" @click="isMbOpen = !isMbOpen">
                        <li><span>EUR</span></li>
                      </button>
                      <div :class="['b', { active: isMbOpen }]">
                        <ul class="crypto-list">
                          <li @click="isMbOpen = false">
                            EUR
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- 輸入額度＋匯率 -->
                  <div class="exchange-rate-frame">
                    <div class="form-input-n input-frame input-dep-amount-frame">
                      <div class="input-title">
                        {{ $t('Bao.amount') }}
                      </div>
                      <div class="input-amount">
                        <input
                          v-model="cryptoAmount"
                          class="input-amount-content"
                          placeholder="0"
                          type="text"
                          @input="validateNumber"
                        >
                        <span class="currency">JPY</span>
                      </div>
                    </div>

                    <div class="crypto">
                      <div class="exchange-rate-box-n">
                        <div class="exchange-rate h5-type">
                          <div v-if="!timeLeft">
                            <span class="currencyA">{{ $t('Bao.current_rate') }}:</span>
                            <span class="currencyB">{{ $t('Bao.expired_rate', { crypto: 'EUR€' }) }}</span>
                          </div>
                          <div v-if="timeLeft > 0">
                            <span class="currencyA">1EUR€</span> =
                            <span class="currencyB">{{ currencyRate.deposit_rate }}JPY</span>
                          </div>
                          <div v-if="timeLeft > 0">
                            <span class="currencyB">{{ cryptoAmount }}EUR€ </span> =
                            <span class="currencyA">{{ currencyRate.currencyRate }}JPY</span>
                          </div>
                        </div>
                        <div class="recheck-bn" @click="timeLeft <= 0 ?handleRecheck(selectedPayment.payment_id) : null">
                          <div v-if="timeLeft > 0" class="countdown-box">
                            {{ formattedTime }}
                          </div>
                          <div v-else class="btn-lock-check">
                            {{ $t('Bao.refresh_rate') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <form class="row-frame dep-form-frame gx-3 form-row-gap">
                    <div class="colu colu-12">
                      <label class="colu-12 for-label" for="電子クーポン-mb-jeton">{{ $t('Bao.jeton_label') }}</label>
                      <input
                        id="電子クーポン-mb-jeton"
                        v-model="Jcash.voucherNumber"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.jeton_voucher')"
                        @input="checkJetonVoucherErrors"
                      >
                      <div v-for="error in jetonVoucherErrors" :key="error" class="input-feedback text-align-R">
                        {{ error }}
                      </div>
                    </div>

                    <div class="colu colu-6 flex-colu">
                      <label class="colu-12 for-label" for="有効期限-mb">{{ $t('Bao.expiration_date') }}</label>
                      <input
                        id="有効期限-mb"
                        v-model="Jcash.expirationDate"
                        maxlength="5"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.expiration_date_placeholder')"
                        @input="formatJcashExpirationDate"
                      >
                      <div v-for="error in JcashExpirationDateErrors" :key="error" class="input-feedback text-align-R">
                        {{ error }}
                      </div>
                    </div>

                    <div class="colu colu-6 flex-colu">
                      <label class="colu-12 for-label" for="CVV / CVC-mb">{{ $t('Bao.security_code') }}</label>
                      <input
                        id="CVV / CVC-mb"
                        v-model="Jcash.securityCode"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.security_code_placeholder')"
                        maxlength="4"
                        @input="formatJcashSecurityCode"
                      >
                      <div v-for="error in JcashSecurityCodeErrors" :key="error" class="input-feedback text-align-R">
                        {{ error }}
                      </div>
                    </div>
                  </form>
                </div>

                <!-- mb 信用卡先隱藏  -->
                <!-- <div v-if="selectedPayment && selectedPayment.typeCode === 'CreditCard'&& selectedPayment.code !== 'HeroPay'" class="slider credit-card-dep-form">
                  <legend class="form-leggend">
                    {{ $t('Bao.payment_info') }}
                  </legend>

                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label class="title col-2" for="credit-select"> {{ $t('Bao.credit_card_num') }}<span class="t-highlight-orange D-none">*</span></label>
                    </div>
                    <div class="col-input pos-relative">
                      <div class="icon-drop" />
                      <select
                        id="credit-select"
                        v-model="selectedCreditCard"
                        class="form-control dep-input-icon-credit"
                      >
                        <option
                          v-for="(type, key) in creditCard.credit_card_number"
                          :key="key"
                          :value="type"
                          class="creditCard"
                          selected=""
                        >
                          {{ type.credit_card_number }}
                        </option>
                      </select>
                    </div>
                    <a class="btn btn-credit-add" @click="$router.push({ path: '/user/bank' })">
                      <span class="icon-add-circle">+</span>
                      <span> {{ $t('Bao.credit_card_add') }}</span>
                    </a>
                    <div v-for="error in jetonVoucherErrors" :key="error" class="invalid_feedback ">
                      {{ error }}
                    </div>
                  </div>
                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label class="title col-2" for="cardholder">
                        {{ $t('Bao.cardholder') }}
                        <span class="t-highlight-orange D-none">*</span></label>
                    </div>
                    <div class="col-input">
                      <input
                        id="cardholder"
                        v-model="creditCard.card_printed_name"
                        class="form-control dep-input-icon-user"
                        type="text"
                        placeholder="TANAKA TARO"
                        :readonly="selectedCreditCard"
                        :class="{ 'locked-input': selectedCreditCard }"
                        @input="checkCreditCardNameErrors"
                      >
                    </div>
                    <div v-for="error in creditCardNameErrors" :key="error" class="invalid_feedback ">
                      {{ error }}
                    </div>
                  </div>
                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label class="title col-2" for="card-date">{{ $t('Bao.credit_card_expire') }}<span class="t-highlight-orange D-none">*</span></label>
                    </div>
                    <div class="col-input">
                      <input
                        id="card-date"
                        v-model="creditCard.expirationDate"
                        class="form-control dep-input-icon-date"
                        type="text"
                        :placeholder="$t('Bao.expiration_date_placeholder')"
                        maxlength="5"
                        :readonly="selectedCreditCard"
                        :class="{ 'locked-input': selectedCreditCard }"
                        @input="formatCreditCardExpirationDate"
                      >
                    </div>
                    <div v-for="error in creditCardExpirationDateErrors" :key="error" class="invalid_feedback ">
                      {{ error }}
                    </div>
                  </div>

                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label class="title col-2 d-flex" for="card-security-code">
                        {{ $t('Bao.credit_card_security') }}
                        <span class="t-highlight-orange D-none">*</span>
                        <a class="cvv btn-credit-cvv">CVV
                          <span class="que-mark" @click="showCVV=true">?</span>
                        </a>
                      </label>
                    </div>
                    <div class="col-input">
                      <input
                        id="card-security-code"
                        v-model="creditCard.securityCode"
                        class="form-control dep-input-icon-security-code"
                        type="text"
                        placeholder="123"
                        maxlength="3"
                        @input="formatCreditCardSecurityCode"
                      >
                    </div>
                    <div
                      v-for="error in creditCardSecurityCodeErrors"
                      :key="error"
                      class="invalid_feedback "
                    >
                      {{ error }}
                    </div>
                  </div>
                </div> -->

                <!-- mb event -->
                <div v-if="memberInfo.member_type !== 3 && sortedEvents" class="promotion-frame ">
                  <div class="promotionTitle">
                    {{ $t('Bao.available_event') }}
                  </div>

                  <div class="promotionDescribe text-center">
                    {{ $t('Bao.select_event') }}
                  </div>

                  <swiper
                    ref="mySwiperPhone"
                    class="promotionBox paginationFrame"
                    :options="swiperOptionPhone"
                  >
                    <swiper-slide
                      v-for="(item, key) in sortedEvents"
                      :key="key"
                      class="promotionCards"
                      :class="{
                        'unopened-event': isUnopenedEvent(item),
                        'active': item.select && selectedEvent !== null
                      }"
                    >
                      <div class="proCheckBox" @click="handleEvent(item)" />
                      <img :src="item.image_deposit" @click="handleEvent(item)">
                    </swiper-slide>

                    <div slot="pagination" class="swiper-pagination" />
                    <div slot="button-prev" class="swiper-button-prev pro-arrow" />
                    <div slot="button-next" class="swiper-button-next pro-arrow" />
                  </swiper>
                </div>

                <!-- mb 總金額、說明 -->
                <div v-show="selectedPayment && selectedPayment.typeNum !== 3" class="deposit-frame-n">
                  <div class="deposit-detail-n">
                    <div class="list">
                      <b>{{ $t('Bao.deposit_amount') }}</b>
                      <span v-if="selectedCrypto">{{ currencyRate.currencyRate | numberFormat }}</span>
                      <span v-else>{{ postForm.amount | numberFormat }}</span>
                      <span>{{ currency }} </span>
                    </div>
                    <div
                      v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'"
                      class="list"
                    >
                      <b>{{ $t('Bao.event_bonus') }}</b>
                      <span>{{ eventBonus | numberFormat }}</span>
                      <span>{{ currency }} </span>
                    </div>
                    <div
                      v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'"
                      class="list text-gold"
                    >
                      <b>{{ $t('Bao.deposit_total_tip') }}</b>
                      <span>{{ calculateTotalBonus() | numberFormat }}</span>
                      <span>{{ currency }} </span>
                    </div>
                  </div>
                  <div v-if="selectedPayment" class="deposit-detail-n">
                    <p v-if="selectedEvent && selectedEvent.type === 'daily_multiple_deposit'">
                      {{ $t('Bao.deposit_credit') }} {{ count }}
                      <br>
                      {{ $t('Bao.deposit_credit_illustrate') }}
                      <br>
                      <br>
                      <template v-if="selectedPayment.typeNum === 3">
                        {{ $t('Bao.payment_crypto_describe_1') }}
                      </template>
                      <template v-else-if="selectedPayment.name === 'VegaWallet'">
                        {{ $t('Bao.payment_vega_describe_1') }}
                        <br>
                        {{ $t('Bao.payment_vega_describe_2') }}
                        <a
                          href="https://vega-wallet.com/whitelist/"
                          target="_blank"
                          class="blue-link"
                        >
                          {{ $t('Bao.payment_vega_describe_3') }}
                        </a>
                      </template>
                      <template v-else>
                        {{ $t('Bao.payment_bank_describe_1') }}
                        <br>
                        {{ $t('Bao.payment_bank_describe_2') }}
                      </template>
                    </p>
                    <p v-else-if="selectedPayment.name === 'VegaWallet'">
                      {{ $t('Bao.payment_vega_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_vega_describe_2') }}
                      <a
                        href="https://vega-wallet.com/whitelist/"
                        target="_blank"
                        class="blue-link"
                      >
                        {{ $t('Bao.payment_vega_describe_3') }}
                      </a>
                    </p>
                    <p v-else-if="selectedPayment.typeNum === 3">
                      {{ $t('Bao.payment_crypto_describe_1') }}
                    </p>

                    <p v-else>
                      {{ $t('Bao.payment_bank_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_bank_describe_2') }}
                    </p>
                  </div>
                </div>

                <!-- mb 存款按鈕 -->
                <div v-show="!selectedType || selectedType !== 3" class="bank-promo-n form-submit-frame">
                  <button class="button-style-16" :disabled="isButtonDisable" @click="checkIsDeposit()">
                    <span>{{ $t('Bao.deposit') }}</span>
                    <span v-if="selectedPayment && selectedPayment.typeNum === 3">
                      {{ formatCryptoAmount() }} JPY
                    </span>
                    <span v-else-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'">
                      {{ postForm.amount | numberFormat }} EUR€
                    </span>
                    <span v-else>
                      {{ postForm.amount | numberFormat }} JPY
                    </span>
                  </button>
                  <a
                    class="help-deposit-n"
                    @click="$router.push('/page/support')"
                  >
                    <span class="icon-help">?</span>
                    <span class="help-text">{{ $t('Bao.deposit_guide') }}</span></a>
                </div>
              </div>
            </div>
          </div>

          <!-- 電腦版流程-->
          <div class="my-deposit-package-n">
            <div class="channel-text-n">
              {{ $t('Bao.deposit') }}
              <span>{{ $t('Bao.payment_select') }}</span>
            </div>
            <!-- pc 上半部選擇存款方式 -->
            <div v-if="outerTypes && outerTypes.length > 0" class="my-money my-wallet-frame-n">
              <div
                v-for="(typeGroup, index) in filteredPaymentTypes"
                :key="index"
                class="wallet-card"
              >
                <div class="bank-choice-item-n bank-choice">
                  <img :src="$getThemeImagePath(getIconName(typeGroup.type))" alt="">
                  <div class="bank-choice-text">
                    <div class="bank-card-title">
                      {{ getTypeName(typeGroup.type) }}
                    </div>
                    <p class="describe-n">
                      {{ getTypeDescription(typeGroup.type) }}
                    </p>
                  </div>
                </div>

                <div class="bank-card-s">
                  <div
                    v-for="payment in typeGroup.paymentMethods"
                    :key="payment.payment_id"
                    class="channel-wrapper-n"
                  >
                    <div
                      class="channel-bank-card-n"
                      :class="{ 'channel-bank-card-on': isSelectedPayment(payment) }"
                    >
                      <div v-if="payment.label && payment.label.length > 0" class="recommended-tags-frame">
                        <div v-if="payment.label[0]" class="recommended-tags red-bg">
                          {{ payment.label[0] }}
                        </div>
                        <div v-if="payment.label[1]" class="recommended-tags">
                          {{ payment.label[1] }}
                        </div>
                      </div>

                      <div
                        class="bank-choice-text grid-container"
                        @click.stop="selectPayment(payment, payment.name, payment.typeCode)"
                      >
                        <div class="icon-deposit">
                          <img :src="payment.image" alt="">
                        </div>
                        <div class="channel-describe-frame">
                          <p class="channel-name-n">
                            {{ payment.name }}
                          </p>
                          <p class="describe-n">
                            {{ $t('Bao.min_to_max') }}:
                            <span class="secondary">{{ payment.amount_limit.min }}-{{ payment.amount_limit.max }}</span>
                          </p>
                        </div>
                      </div>
                      <p class="fs-10px text-align-L flex-fill announcement">
                        {{ payment.announcement }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- pc 下半部-->
            <div class="slider-form form-frame">
              <!-- pc 加密貨幣 選擇貨幣 -->
              <crypto-detail v-if="!isMobile() && selectedPayment && selectedPayment.typeNum === 3" :selected-payment="selectedPayment" class="row-frame g-3 colu-12" />

              <div v-if="selectedPayment && (selectedPayment.typeNum !== 3 && selectedPayment.typeCode !== 'PayPal' && selectedPayment.typeCode !== 'JetonCash')" class="input-amount-group">
                <div class="form-input-n input-frame input-dep-amount-frame">
                  <div class="input-title">
                    {{ $t('Bao.amount') }} :
                  </div>
                  <div class="input-amount">
                    <input
                      :value="inputAmount"
                      class="input-amount-content"
                      type="text"
                      placeholder="0"
                      @input="validateNumber"
                    >
                    <span class="currency">JPY</span>
                  </div>
                </div>

                <div v-if="selectedPayment.typeNum !== 3" class="amount-range-frame">
                  <ul class="slider-number">
                    <li
                      v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                      :key="key"
                      @click="handleAmount(price)"
                    >
                      {{ price | numberFormat }}
                    </li>
                  </ul>
                  <ul class="slider-dot">
                    <li
                      v-for="(price, key) in selectedPayment.price_list.slice(0,5)"
                      :key="key"
                      @click="handleAmount(price)"
                    >
                      <img :src="$getThemeImagePath('dot.svg')" alt="">
                    </li>
                  </ul>
                  <div class="slider-bar" />
                  <div
                    v-show="selectedAmount"
                    class="slider-bar og"
                    :style="{ width: percent + '%' }"
                  >
                    <img :src="$getThemeImagePath('dot-orange.svg')" alt="">
                  </div>
                </div>
              </div>
              <!-- pc JetonCash -->
              <template v-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'">
                <div class="crypto-select-frame">
                  <label class="colu-12 for-label" for="">{{ $t('Bao.currency') }}</label>
                  <div class="lang-select">
                    <button class="btn-select" value="EUR" @click="isOpen = !isOpen">
                      <li>
                        <span>
                          EUR
                        </span>
                      </li>
                    </button>
                    <div :class="['b', { active: isOpen }]">
                      <ul class="crypto-list">
                        <li @click="isOpen = false">
                          <span>EUR</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="ch-crypto-form">
                  <div class="input-amount-group">
                    <div class="form-input-n input-frame input-dep-amount-frame">
                      <div class="input-title">
                        {{ $t('Bao.amount') }}
                      </div>
                      <div class="input-amount">
                        <input
                          v-model="cryptoAmount"
                          class="input-amount-content"
                          type="text"
                          placeholder="0"
                          @input="validateNumber"
                        >
                        <span class="currency">JPY</span>
                      </div>
                    </div>
                  </div>

                  <div class="crypto">
                    <div class="crypto-infor">
                      <div class="exchange-rate-box-n">
                        <div class="exchange-rate">
                          <div v-if="!timeLeft">
                            <span class="currencyA">{{ $t('Bao.current_rate') }}:</span>
                            <span class="currencyB">{{ $t('Bao.expired_rate', { crypto: 'EUR€' }) }}</span>
                          </div>
                          <div v-if="timeLeft > 0">
                            <span class="currencyA"> 1EUR€ </span> = <span class="currencyB"> {{ currencyRate.deposit_rate }}JPY</span>
                          </div>
                          <div v-if="timeLeft > 0">
                            <span class="currencyA"> {{ cryptoAmount }} EUR€ </span> =
                            <span class="currencyB">{{ currencyRate.currencyRate }}JPY</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="recheck-bn" @click="timeLeft <= 0 ? handleRecheck(selectedPayment.payment_id) : null">
                      <div v-if="timeLeft > 0" class="countdown-box">
                        {{ formattedTime }}
                      </div>
                      <div v-else class="btn-lock-check">
                        {{ $t('Bao.refresh_rate') }}
                      </div>
                    </div>
                  </div>
                </div>

                <form class="row-frame dep-form-frame colu-12 ml-0 gx-3 form-row-gap">
                  <div class="colu colu-12">
                    <label class="colu-12 for-label" for="電子クーポン">{{ $t('Bao.jeton_label') }}</label>
                    <input
                      id="電子クーポン"
                      v-model="Jcash.voucherNumber"
                      class="for-input inpType"
                      type="text"
                      :placeholder="$t('Bao.jeton_voucher')"
                      maxlength="19"
                      @input="checkJetonVoucherErrors"
                    >
                    <div v-for="error in jetonVoucherErrors" :key="error" class="input-feedback text-align-R">
                      {{ error }}
                    </div>
                  </div>

                  <div class="colu colu-6 flex-colu">
                    <label class="colu-12 for-label" for="有効期限">{{ $t('Bao.expiration_date') }}</label>
                    <input
                      id="有効期限"
                      v-model="Jcash.expirationDate"
                      maxlength="5"
                      class="for-input inpType"
                      type="text"
                      :placeholder="$t('Bao.expiration_date_placeholder')"
                      @input="formatJcashExpirationDate"
                    >
                    <div v-for="error in JcashExpirationDateErrors" :key="error" class="input-feedback text-align-R">
                      {{ error }}
                    </div>
                  </div>

                  <div class="colu colu-6 flex-colu">
                    <label class="colu-12 for-label" for="CVV / CVC">{{ $t('Bao.security_code') }}</label>
                    <input
                      id="CVV / CVC"
                      v-model="Jcash.securityCode"
                      class="for-input inpType"
                      type="text"
                      :placeholder="$t('Bao.security_code_placeholder')"
                      maxlength="4"
                      @input="formatJcashSecurityCode"
                    >
                    <div v-for="error in JcashSecurityCodeErrors" :key="error" class="input-feedback text-align-R">
                      {{ error }}
                    </div>
                  </div>
                </form>
              </template>

              <!-- pc PayPal -->
              <div v-if="selectedPayment && selectedPayment.typeCode === 'PayPal'" class="fastDepositFrame">
                <div class="FD-title text-center">
                  {{ $t('Bao.prize_select') }}
                </div>
                <div class="FD-amount-box">
                  <div
                    v-for="(price, key) in selectedPayment.price_list"
                    :key="key"
                    :class="selectedAmount === price ? 'active' : ''"
                    class="FD-amount-item"
                    @click="handleAmount(price)"
                  >
                    ¥{{ price }}
                  </div>
                </div>
              </div>

              <!-- pc event -->
              <div
                v-if="memberInfo.member_type !== 3 && sortedEvents"
                v-once
                class="promotion-frame"
                @click="handlePromoClick"
              >
                <div class="promotionTitle">
                  {{ $t('Bao.available_event') }}
                </div>
                <div class="promotionDescribe text-center">
                  {{ $t('Bao.select_event') }}
                </div>
                <swiper
                  ref="mySwiper"
                  class="promotionBox paginationFrame"
                  :options="swiperOption"
                >
                  <swiper-slide
                    v-for="(item, key) in sortedEvents"
                    :key="key"
                    class="promotionCards"
                    :class="{
                      'unopened-event': isUnopenedEvent(item),
                    }"
                    :data-event-index="key"
                    :data-event-id="item.id"
                  >
                    <div class="proCheckBox" />
                    <img :src="item.image_deposit">
                  </swiper-slide>

                  <div slot="pagination" class="swiper-pagination" />
                  <div slot="button-prev" class="swiper-button-prev pro-arrow" />
                  <div slot="button-next" class="swiper-button-next pro-arrow" />
                </swiper>
              </div>

              <!-- pc 總金額、說明 -->
              <div v-if="selectedPayment && selectedPayment.typeNum !== 3" class="deposit-frame-n">
                <div class="deposit-detail-n">
                  <div class="list">
                    <b>{{ $t('Bao.deposit_amount') }}</b>
                    <span v-if="selectedCrypto">{{ currencyRate.currencyRate | numberFormat }}</span>
                    <span v-else>{{ postForm.amount | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                  <div v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'" class="list">
                    <b>{{ $t('Bao.event_bonus') }}</b>
                    <span>{{ eventBonus | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                  <div v-if="!selectedEvent || selectedEvent.type !== 'daily_multiple_deposit'" class="list text-gold">
                    <b>{{ $t('Bao.deposit_total_tip') }}</b>
                    <span>{{ calculateTotalBonus() | numberFormat }}</span>
                    <span>{{ currency }} </span>
                  </div>
                </div>

                <div v-if="selectedPayment" class="deposit-detail-n">
                  <p v-if="selectedEvent && selectedEvent.type === 'daily_multiple_deposit'">
                    {{ $t('Bao.deposit_credit') }} {{ count }}
                    <br>
                    {{ $t('Bao.deposit_credit_illustrate') }}
                    <br>
                    <br>
                    <template v-if="selectedPayment.typeNum === 3">
                      {{ $t('Bao.payment_crypto_describe_1') }}
                    </template>
                    <template v-else-if="selectedPayment.name === 'VegaWallet'">
                      {{ $t('Bao.payment_vega_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_vega_describe_2') }}
                      <a
                        href="https://vega-wallet.com/whitelist/"
                        target="_blank"
                        class="blue-link"
                      >
                        {{ $t('Bao.payment_vega_describe_3') }}
                      </a>
                    </template>
                    <template v-else>
                      {{ $t('Bao.payment_bank_describe_1') }}
                      <br>
                      {{ $t('Bao.payment_bank_describe_2') }}
                    </template>
                  </p>
                  <p v-else-if="selectedPayment.name === 'VegaWallet'">
                    {{ $t('Bao.payment_vega_describe_1') }}
                    <br>
                    {{ $t('Bao.payment_vega_describe_2') }}
                    <a
                      href="https://vega-wallet.com/whitelist/"
                      target="_blank"
                      class="blue-link"
                    >
                      {{ $t('Bao.payment_vega_describe_3') }}
                    </a>
                  </p>
                  <p v-else-if="selectedPayment.typeNum === 3">
                    {{ $t('Bao.payment_crypto_describe_1') }}
                  </p>

                  <p v-else>
                    {{ $t('Bao.payment_bank_describe_1') }}
                    <br>
                    {{ $t('Bao.payment_bank_describe_2') }}
                  </p>
                </div>
              </div>

              <!-- pc VegaWallet -->
              <form v-if="selectedPayment && selectedPayment.name === 'VegaWallet'" class="dep-form-frame colu-12 ga-4">
                <div class="colu colu-12">
                  <label class="colu-12 for-label" for="Vega Walletパスワード">{{ $t('Bao.deposit_account') }}</label>
                  <input
                    id="Vega Walletパスワード"
                    v-model="other.uid"
                    class="for-input"
                    type="text"
                    :placeholder="$t('Bao.deposit_account')"
                    @input="checkAccountErrors"
                  >
                  <div v-for="error in accountErrors" :key="error" class="input-feedback text-align-R">
                    {{ error }}
                  </div>
                </div>

                <div class="colu colu-12">
                  <label class="colu-12 for-label" for="Vega WalletユーザーID">{{ $t('Bao.deposit_password') }}</label>
                  <input
                    id="Vega WalletユーザーID"
                    v-model="other.password"
                    v-validate="'required'"
                    class="for-input"
                    name="password"
                    type="password"
                    :placeholder="$t('Bao.deposit_password')"
                  >
                  <div v-if="errors.has('password')" class="input-feedback text-align-R">
                    {{ $t("Bao.deposit_password_error") }}
                  </div>
                </div>
              </form>

              <!-- pc JetonPay -->
              <form v-if="selectedPayment && selectedPayment.name === 'JetonPay'" class="dep-form-frame colu-12 ga-4">
                <div class="colu colu-12">
                  <label class="colu-12 for-label">{{ $t('Bao.jeton_account') }}</label>
                  <input
                    v-model="Jcash.voucherNumber"
                    class="for-input"
                    type="text"
                    :placeholder="$t('Bao.jeton_account')"
                    @input="checkJetonErrors"
                  >
                  <div v-for="error in jetonErrors" :key="error" class="input-feedback text-align-R">
                    {{ error }}
                  </div>
                </div>
              </form>

              <!-- pc 信用卡先隱藏 -->
              <!-- <div v-if="selectedPayment && selectedPayment.typeCode === 'CreditCard'&& selectedPayment.code !== 'HeroPay'" class="slider credit-card-dep-form">
                  <legend class="form-leggend">
                    {{ $t('Bao.payment_info') }}
                  </legend>

                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label class="title col-2" for="credit-select"> {{ $t('Bao.credit_card_num') }}<span class="t-highlight-orange D-none">*</span></label>
                    </div>
                    <div class="col-input pos-relative">
                      <div class="icon-drop" />
                      <select
                        id="credit-select"
                        v-model="selectedCreditCard"
                        class="form-control dep-input-icon-credit"
                      >
                        <option
                          v-for="(type, key) in creditCard.credit_card_number"
                          :key="key"
                          :value="type"
                          class="creditCard"
                          selected=""
                        >
                          {{ type.credit_card_number }}
                        </option>
                      </select>
                    </div>
                    <a class="btn btn-credit-add" @click="$router.push({ path: '/user/bank' })">
                      <span class="icon-add-circle">+</span>
                      <span> {{ $t('Bao.credit_card_add') }}</span>
                    </a>
                    <div v-for="error in jetonVoucherErrors" :key="error" class="invalid_feedback ">
                      {{ error }}
                    </div>
                  </div>
                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label class="title col-2" for="cardholder">
                        {{ $t('Bao.cardholder') }}
                        <span class="t-highlight-orange D-none">*</span></label>
                    </div>
                    <div class="col-input">
                      <input
                        id="cardholder"
                        v-model="creditCard.card_printed_name"
                        class="form-control dep-input-icon-user"
                        type="text"
                        placeholder="TANAKA TARO"
                        :readonly="selectedCreditCard"
                        :class="{ 'locked-input': selectedCreditCard }"
                        @input="checkCreditCardNameErrors"
                      >
                    </div>
                    <div v-for="error in creditCardNameErrors" :key="error" class="invalid_feedback ">
                      {{ error }}
                    </div>
                  </div>
                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label class="title col-2" for="card-date">{{ $t('Bao.credit_card_expire') }}<span class="t-highlight-orange D-none">*</span></label>
                    </div>
                    <div class="col-input">
                      <input
                        id="card-date"
                        v-model="creditCard.expirationDate"
                        class="form-control dep-input-icon-date"
                        type="text"
                        :placeholder="$t('Bao.expiration_date_placeholder')"
                        maxlength="5"
                        :readonly="selectedCreditCard"
                        :class="{ 'locked-input': selectedCreditCard }"
                        @input="formatCreditCardExpirationDate"
                      >
                    </div>
                    <div v-for="error in creditCardExpirationDateErrors" :key="error" class="invalid_feedback ">
                      {{ error }}
                    </div>
                  </div>

                  <div class="form-input-package form-mb">
                    <div class="col-input-title">
                      <label
                        class="title col-2 d-flex"
                        for="card-security-code"
                      >{{ $t('Bao.credit_card_security') }}
                        <span class="t-highlight-orange D-none">*</span>
                        <a class="cvv btn-credit-cvv">CVV
                          <span class="que-mark" @click="showCVV=true">?</span>
                        </a>
                      </label>
                    </div>
                    <div class="col-input">
                      <input
                        id="card-security-code"
                        v-model="creditCard.securityCode"
                        class="form-control dep-input-icon-security-code"
                        type="text"
                        placeholder="123"
                        maxlength="3"
                        @input="formatCreditCardSecurityCode"
                      >
                    </div>
                    <div
                      v-for="error in creditCardSecurityCodeErrors"
                      :key="error"
                      class="invalid_feedback "
                    >
                      {{ error }}
                    </div>
                  </div>
                </div> -->

              <!-- pc 存款按鈕 -->
              <div v-show="!selectedPayment || selectedPayment.typeNum !== 3" class="bank-promo-n form-submit-frame">
                <button class="button-style-16" :disabled="isButtonDisable" @click="checkIsDeposit()">
                  <span>{{ $t('Bao.deposit') }}
                    <template v-if="selectedPayment && selectedPayment.typeNum === 3">
                      {{ formatCryptoAmount() }} JPY
                    </template>
                    <template v-else-if="selectedPayment && selectedPayment.typeCode === 'JetonCash'">
                      {{ postForm.amount | numberFormat }} EUR€
                    </template>
                    <template v-else>
                      {{ postForm.amount | numberFormat }} JPY
                    </template>
                  </span>
                </button>
                <a
                  class="help-deposit-n"
                  @click="$router.push('/page/support')"
                >
                  <span class="icon-help">?</span>
                  <span class="help-text">{{ $t('Bao.deposit_guide') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 首存提示視窗 -->
      <div v-if="showModel" class="popup-wrap text-center" :class="{ active: showModel }">
        <div class="popup-box">
          <div class="popup-success deposit">
            <h5>
              {{ $t('Bao.is_handle_deposit') }}
            </h5>
            <button class="button-style-5" @click="handleSubmit">
              <span>{{ $t('Bao.submit') }}</span>
            </button>
            <button class="button-style-5" @click="hideModel">
              <span>{{ $t('Bao.cancel') }}</span>
            </button>
          </div>
          <a class="popup-close" @click="hideModel" />
        </div>
      </div>

      <!-- 安全碼提示視窗 -->
      <div v-if="showCVV" class="popup-frame popup-card-cvv" :class="{'active': showCVV}">
        <cardCVV v-if="showCVV" @closeCVV="closeCVV" />
      </div>
    </div>
  </div>
</template>

<script>
import { showNotice, setErrorMessage, detectMob } from '@/utils/tool'
import cardCVV from '@/components/modal/cardCVV'
import cryptoDetail from '@/components/deposit/cryptoDetail'
import {
  DepositType,
  DepositPayment,
  DepositSetting,
  DepositTransactions,
  checkDepositRate,
  checkDepositCryptoRate
} from '@/api/payment'
import { getMyCreditCards } from '@/api/bank'
import { page } from '@/api/common'
import { getEvent, getEventDetail, joinEvent, getEventQualification } from '@/api/event'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import crypto from 'crypto-js'
import { mapGetters } from 'vuex'

export default {
  components: {
    Swiper,
    SwiperSlide,
    cardCVV,
    cryptoDetail
  },
  data() {
    const postForm = {
      payment_id: null,
      amount: 0,
      userName: '',
      join_event_info: [],
      event_type: null,
      default: null
    }
    return {
      other: [],
      cryptoAmount: '',
      selectedType: null,
      outerTypes: [],
      types: [],
      selectedPayment: null,
      postForm,
      events: [],
      eventBonus: 0,
      selectedEvent: null,
      deposit_v2: null,
      selectedAmount: null,
      selectedCrypto: {},
      selectedTypeName: '',
      selectedTypeCode: '',
      showCVV: false,
      percent: 0,
      swiperOption: {
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1450: {
            slidesPerView: 3.5
          },
          1300: {
            slidesPerView: 2.7
          },
          1120: {
            slidesPerView: 2.2
          },
          992: {
            slidesPerView: 1.3
          }
        }
      },
      swiperOptionPhone: {
        slidesPerView: 1.3,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      count: 0,
      multipleDeposit: [],
      bounsLowerLimit: 0,
      todayArr: [],
      checkQual: true,
      lastResponseMessage: '',
      timer: null,
      timeLeft: 0, // 5 minutes in seconds
      accountErrors: [],
      jetonErrors: [],
      jetonVoucherErrors: [],
      JcashExpirationDateErrors: [],
      JcashSecurityCodeErrors: [],
      creditCardNameErrors: [],
      creditCardNumErrors: [],
      creditCardExpirationDateErrors: [],
      creditCardSecurityCodeErrors: [],
      selectedCreditCard: null,
      depositEventRule: '',
      depositConfirmMessage: '',
      Jcash: {
        voucherNumber: '',
        expirationDate: '',
        securityCode: '',
        currency: 'EUR'
      },
      creditCard: {
        card_printed_name: '',
        credit_card_number: '',
        expirationDate: '',
        securityCode: ''
      },
      showModel: false,
      isOpen: false,
      isMbOpen: false
    }
  },
  computed: {
    ...mapGetters(['user', 'memberInfo', 'brand', 'brandInfo', 'permissionInfo']),
    filteredPaymentTypes() {
      // 確保按照 type 2, 1, 3, 4 的順序排序
      return this.outerTypes
        .filter(type => type.paymentMethods.length > 0)
        .sort((a, b) => {
          const order = { 2: 0, 1: 1, 3: 2, 4: 3 }
          return order[a.type] - order[b.type]
        })
    },
    currencyRate() {
      let isCheck
      if (this.selectedPayment && (this.selectedPayment.typeCode === 'JetonCash' || this.selectedPayment.typeNum === 3)) {
        isCheck = this.types.find(type => type.typeName === this.selectedCrypto.typeName)
      }
      if (isCheck) {
        let exchangeRate
        if (this.selectedPayment.typeNum === 3) {
          exchangeRate = this.cryptoAmount / isCheck.deposit_rate
        } else {
          exchangeRate = this.cryptoAmount * isCheck.deposit_rate
        }

        if (exchangeRate % 1 !== 0) {
          return {
            currencyRate: Number(exchangeRate).toFixed(4),
            deposit_rate: isCheck.deposit_rate,
            deposit_divide: 1 / isCheck.deposit_rate,
            payment_id: isCheck.payment_id,
            fetchName: isCheck.typeName
          }
        } else {
          return {
            currencyRate: exchangeRate,
            deposit_rate: isCheck.deposit_rate,
            deposit_divide: 1 / isCheck.deposit_rate,
            payment_id: isCheck.payment_id,
            fetchName: isCheck.typeName
          }
        }
      }
      return {
        currencyRate: 0,
        deposit_rate: 0,
        payment_id: 0
      }
    },
    filteredTypes() {
      if (this.selectedPayment) {
        return this.types
          .filter(type => type.typeNum === 3)
          .filter(type => type.name === this.selectedPayment.name)
      } return []
    },
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60)
      const seconds = this.timeLeft % 60
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    isButtonDisable() {
      const num = parseInt(this.postForm.amount, 10)
      const isInvalidAmount = isNaN(num) || num <= 0
      const cryptonNum = parseFloat(this.cryptoAmount)
      const isInvalidCryptonNumAmount = isNaN(cryptonNum) || cryptonNum <= 0
      const isDailyMultipleDeposit =
        this.selectedEvent && this.selectedEvent.type === 'daily_multiple_deposit' &&
        this.selectedPayment && num < this.bounsLowerLimit

      if (this.selectedCrypto && this.selectedCrypto.typeCode !== 'JetonCash') {
        return this.postForm.payment_id === null || isInvalidCryptonNumAmount || !this.timeLeft ||
              (this.selectedEvent && this.selectedEvent.type === 'daily_multiple_deposit' &&
               this.selectedPayment &&
               this.cryptoAmount < this.bounsLowerLimit)
      }

      if (this.selectedPayment && this.selectedPayment.name === 'VegaWallet') {
        const accountErrors = this.accountErrors
        return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit ||
              !this.other.password || accountErrors.length > 0
      } else if (this.selectedPayment && this.selectedPayment.name === 'JetonPay') {
        const accountErrors = this.jetonErrors
        return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit || !this.other.uid || accountErrors.length > 0
      } else if (this.selectedPayment && this.selectedPayment.typeCode === 'JetonCash') {
        return this.postForm.payment_id === null || isDailyMultipleDeposit ||
               this.jetonVoucherErrors.length > 0 || this.JcashExpirationDateErrors.length > 0 ||
               this.JcashSecurityCodeErrors.length > 0 ||
              !this.Jcash.voucherNumber || !this.Jcash.expirationDate ||
              !this.Jcash.securityCode || !this.Jcash.currency || isInvalidAmount
      } else if (this.selectedPayment && this.selectedPayment.typeCode === 'CreditCard' && this.selectedPayment.code !== 'HeroPay') {
        return this.postForm.payment_id === null || isDailyMultipleDeposit ||
               this.creditCardNameErrors.length > 0 || this.creditCardNumErrors.length > 0 ||
               this.creditCardExpirationDateErrors.length > 0 ||
               this.creditCardSecurityCodeErrors.length > 0 ||
               this.creditCard.credit_card_number.length === 0 || !this.creditCard.expirationDate ||
              !this.creditCard.securityCode || isInvalidAmount ||
              !this.creditCard.card_printed_name
      }

      return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit
    },
    sortedEvents() {
      const events = [...this.user.sortedEvents]
      const allUnopened = events.every(event => this.isUnopenedEvent(event))
      if (allUnopened) return null

      return events.sort((a, b) => {
        if (this.isUnopenedEvent(a) && !this.isUnopenedEvent(b)) {
          return 1 // a is unopened, b is not, a goes behind b
        } else if (!this.isUnopenedEvent(a) && this.isUnopenedEvent(b)) {
          return -1 // a is not unopened, b is, a goes in front of b
        }
        return 0 // both are either unopened or not, keep original order
      })
    },
    activityCount() {
      if (this.multipleDeposit) {
        return this.multipleDeposit.setting.reduce((count, week) => {
          if (week.condition_value === this.getDayNumber()) {
            return count + 1
          }
          return count
        }, 0)
      }
      return 0
    },
    swiper() {
      return this.sortedEvents ? this.$refs.mySwiper.$swiper : ''
    },
    swiperPhone() {
      return this.sortedEvents ? this.$refs.mySwiperPhone.$swiper : ''
    },
    first_deposit_at() {
      return this.memberInfo.first_deposit_at
    },
    currency() {
      return this.brand.currency
    },
    before_withdrawal_module_setting() {
      return this.brandInfo.before_withdrawal_module_setting
    },
    inputAmount() {
      return this.selectedPayment && this.selectedPayment.typeNum === 3
        ? this.cryptoAmount
        : this.postForm.amount
    }
  },
  watch: {
    selectedEvent() {
      this.calculateBonus()
    },
    selectedCreditCard() {
      // Extract month and year
      const month = this.selectedCreditCard.expire_month
      const year = this.selectedCreditCard.expire_year

      // Format the expiration date
      this.creditCard.expirationDate = this.formatCardExpirationDateWhenSelect(month, year)
      this.creditCard.card_printed_name = this.selectedCreditCard.card_printed_name
    },
    'postForm.amount'() {
      this.calculateBonus()
    },
    'cryptoAmount'() {
      this.calculateBonus()
    },
    selectedCrypto(newValue, oldValue) {
      if (newValue) {
        this.resetTimer()
      }
    },
    filteredTypes(newVal) {
      if (newVal.length > 0) {
        this.selectedCrypto = newVal[0]
      }
    }
  },
  created() {
    DepositType()
      .then((response) => {
        // Flatten the types and their payments into a single array
        // where each payment item includes its parent type's information.
        const flattenedPayments = response.data.data.reduce((acc, type) => {
          // Map each payment to include type information
          const paymentsWithTypeInfo = type.payments.map(payment => ({
            ...payment, // Include all properties of the payment
            typeName: type.name,
            typeCode: type.code,
            typeNum: type.type,
            typeImage: type.image,
            typeHey: type.hey
          }))
          return acc.concat(paymentsWithTypeInfo)
        }, [])

        // Group payments by type
        const groupedPayments = flattenedPayments.reduce((acc, payment) => {
          const existingType = acc.find(item => item.type === payment.typeNum)

          if (existingType) {
            const existingPayment = existingType.paymentMethods.find(pm => pm.name === payment.name)
            if (!existingPayment) {
              existingType.paymentMethods.push(payment)
            }
          } else {
            acc.push({
              type: payment.typeNum,
              paymentMethods: [payment]
            })
          }
          return acc
        }, [])

        const predefinedTypes = [
          { type: 2, paymentMethods: [] },
          { type: 1, paymentMethods: [] },
          { type: 3, paymentMethods: [] },
          { type: 4, paymentMethods: [] }
        ]

        // Merge actual data into the predefined structure
        this.outerTypes = predefinedTypes.map(predefType => {
          const actualType = groupedPayments.find(group => group.type === predefType.type)
          return actualType || predefType // Use actual type if found, otherwise use empty predefined type
        })

        this.outerTypes.forEach(type => {
          type.paymentMethods = type.paymentMethods.filter(payment =>
            payment.allow_member_level.includes(String(this.memberInfo.vl)) &&
            payment.typeHey === this.memberInfo.vip_level_id
          )
        })
        this.types = flattenedPayments
      })
      .catch(() => {
        // Handle error
      })
    getMyCreditCards().then((response) => {
      this.creditCard.credit_card_number = response.data.data
    })

    page({ type: 'deposit_event_rule' }).then(response => {
      this.depositEventRule = response.data.data.content
    })
    page({ type: 'deposit_confirm_message' }).then(response => {
      this.depositConfirmMessage = response.data.data.content
    })

    getEvent()
      .then((response) => {
        for (const item of response.data.data.list) {
          if (item.is_show_in_deposit !== 0) {
            if (item.type === 'deposit_v2') {
              this.events.push(item)
              this.deposit_v2 = item.id
            }
            if (item.is_show_in_deposit === 1) {
              if (item.type === 'daily_multiple_deposit' && this.memberInfo.third_deposit_amount !== 0) {
                this.getTransactions()
                this.events.push(item)
              } else if (item.type !== 'deposit_v2' && item.type !== 'daily_multiple_deposit') {
                this.events.push(item)
              }
            }
          }
        }
        this.$store.dispatch('initializeSortedEvents', this.events)
        for (const i in this.events) {
          getEventDetail(this.events[i].id).then(response => {
            const event = response.data.data
            if (event.type === 'daily_multiple_deposit') {
              this.multipleDeposit = event
              event.setting.forEach(item => {
                if (item.condition_value === this.getDayNumber()) {
                  this.todayArr.push(item)
                }
              })
            }
            event.select = false
            this.events.splice(i, 1, event)
          })
        }
        if (this.sortedEvents) {
          this.updateSwiperWrapperStyle()
        }
      })
    DepositSetting()
      .then((response) => {
        this.postForm.default = parseInt(parseFloat(response.data.data.info.default_deposit_amount))
      }).catch((error) => {
        const result = error.response.data
        if (result.status === 403) {
          showNotice(result.msg, () => {
            this.$router.push('/')
          })
        }
      })
  },
  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getIconName(type) {
      const iconMap = {
        2: 'electron-gold.svg',
        1: 'bankB-gold.svg',
        3: 'bitcoin-btc-gold.svg',
        4: 'card-gold.svg'
      }
      return iconMap[type] || 'default-gold.svg'
    },
    getTypeName(type) {
      const nameMap = {
        2: this.$t('Bao.channel_epay'),
        1: this.$t('Bao.channel_bank'),
        3: this.$t('Bao.channel_crypto'),
        4: this.$t('Bao.credit_card')
      }
      return nameMap[type] || ''
    },
    getTypeDescription(type) {
      const descMap = {
        2: this.$t('Bao.e-payment'),
        1: this.$t('Bao.internet_bank_app'),
        3: this.$t('Bao.bitcoin_ethereum'),
        4: this.$t('Bao.internet_bank_app')
      }
      return descMap[type] || ''
    },
    updateSwiperWrapperStyle() {
      this.$nextTick(() => {
        const swiperWrapper = this.swiper.$wrapperEl[0]
        const swiperPhoneWrapper = this.swiperPhone.$wrapperEl[0]

        if (swiperWrapper && this.sortedEvents.length < 4) {
          swiperWrapper.style.display = 'flex'
          swiperWrapper.style.justifyContent = 'center'

          const slides = swiperWrapper.querySelectorAll('.swiper-slide')
          slides.forEach(slide => {
            slide.style.width = 'auto'
            slide.style.paddingLeft = '30px'
            slide.style.height = '150px'
          })
        }

        if (swiperPhoneWrapper && this.sortedEvents.length < 2) {
          swiperPhoneWrapper.style.display = 'flex'
          swiperPhoneWrapper.style.justifyContent = 'center'

          const slides = swiperPhoneWrapper.querySelectorAll('.swiper-slide')[0]
          slides.style.margin = 'auto'
        }
      })
    },
    checkJetonErrors() {
      this.jetonErrors = []
      if (!this.other.uid) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      } else if (!/^\d+$/.test(this.other.uid)) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      }
    },
    checkCreditCardNameErrors() {
      const errorMessage = this.$t('Bao.credit_card_name_error')

      if (!this.creditCard.card_printed_name) {
        // Check if the error message is not already in the array
        if (!this.creditCardNameErrors.includes(errorMessage)) {
          this.creditCardNameErrors.push(errorMessage)
        }
      } else {
        // Remove the error message if the input is not empty
        const index = this.creditCardNameErrors.indexOf(errorMessage)
        if (index !== -1) {
          this.creditCardNameErrors.splice(index, 1)
        }
      }
    },
    checkJetonVoucherErrors() {
      this.jetonVoucherErrors = []
      const input = this.Jcash.voucherNumber.replace(/\D/g, '') // Remove non-digits
      this.Jcash.voucherNumber = input.slice(0, 19) // Limit to 19 digits(0, 19)
      if (this.Jcash.voucherNumber.length < 19) {
        this.jetonVoucherErrors.push(this.$t('Bao.jeton_voucher_error'))
      }
    },
    formatCardExpirationDateWhenSelect(month, year) {
      // Ensure month is two digits
      const formattedMonth = month.padStart(2, '0')

      // Extract last two digits of the year
      const formattedYear = year.slice(-2)

      return `${formattedMonth}/${formattedYear}`
    },
    formatCreditCardExpirationDate(event) {
      this.formatExpirationDate(event, 'creditCard')
    },
    formatJcashExpirationDate(event) {
      this.formatExpirationDate(event, 'Jcash')
    },
    formatExpirationDate(event, field) {
      let input = event.target.value.replace(/\D/g, '') // Remove non-digits
      if (input.length > 2) {
        input = input.slice(0, 2) + '/' + input.slice(2)
      }
      this[field].expirationDate = input
      this.checkExpirationDateErrors(field)
    },
    checkExpirationDateErrors(field) {
      const errorField = `${field}ExpirationDateErrors`
      this[errorField] = []
      const [month, year] = this[field].expirationDate.split('/')

      if (this[field].expirationDate.length < 5) {
        // Don't show error if the user hasn't finished typing
        return
      }

      this[field].expiryMonth = month
      this[field].expiryYear = `20${year}`

      if (!/^\d{2}\/\d{2}$/.test(this[field].expirationDate)) {
        this[errorField].push(this.$t('Bao.expiration_date_error'))
      } else if (parseInt(month) < 1 || parseInt(month) > 12) {
        this[errorField].push(this.$t('Bao.expiration_date_error'))
      } else {
        // Check if the expiration date is in the past
        const currentDate = new Date()
        const expirationDate = new Date(parseInt(`20${year}`), parseInt(month) - 1)

        if (expirationDate < currentDate) {
          this[errorField].push(this.$t('Bao.expiration_date_past_error'))
        }
      }
    },
    formatCreditCardSecurityCode(event) {
      this.formatSecurityCode(event, 'creditCard')
    },
    formatJcashSecurityCode(event) {
      this.formatSecurityCode(event, 'Jcash')
    },
    formatSecurityCode(event, field) {
      const input = event.target.value.replace(/\D/g, '') // Remove non-digits
      this[field].securityCode = input.substr(0, 4)
      this.checkSecurityCodeErrors(field)
    },
    checkSecurityCodeErrors(field) {
      const errorField = `${field}SecurityCodeErrors`
      this[errorField] = []
      if (field === 'Jcash' && this[field].securityCode.length < 4) {
        this[errorField].push(this.$t('Bao.security_code_error'))
        return
      }
      if (field === 'creditCard' && this[field].securityCode.length < 3) {
        this[errorField].push(this.$t('Bao.security_code_error'))
        return
      }
    },
    checkAccountErrors() {
      this.accountErrors = []
      if (!this.other.uid) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      } else if (!/^[a-zA-Z]\d{6}$/.test(this.other.uid)) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      }
    },
    selectType(type) {
      // Toggle type selection (click again to deselect)
      this.selectedType = type
      // Reset selected payment when changing type
      this.postForm.amount = this.postForm.default
      this.cryptoAmount = ''
      this.selectedAmount = 0
      this.selectedPayment = null
      this.postForm.payment_id = null

      if (this.selectedType.type === 3) {
        this.postForm.amount = 0
      }
    },
    selectPayment(payment, name, code) {
      const kycMapping = {
        1: 'enable_KYC_deposit_channel',
        2: 'enable_KYC_deposit_ewallet',
        3: 'enable_KYC_deposit_cryptocurrency'
      }

      const kycKey = kycMapping[payment.typeNum]

      if (kycKey && this.permissionInfo[kycKey] && this.memberInfo.is_pass_KYC !== 1) {
        // 若該金流需 KYC，且用戶尚未完成驗證
        showNotice('アカウントの安全のため、入金前に KYC認証を完了してください。', () => {
          this.$router.push({
            path: '/user/edit'
          })
        })
        return
      }

      this.percent = 0
      this.postForm.amount = this.postForm.default
      if (payment.typeCode === 'JetonCash') {
        this.selectedCrypto = payment
      } else {
        this.selectedCrypto = null
      }
      this.selectedTypeCode = code
      this.selectedPayment = payment
      this.postForm.payment_id = payment.payment_id
      this.selectedTypeName = name
      if (code === 'BankToBank') {
        if (!this.memberInfo.romanization) {
          showNotice(this.$t('Bao.credit_card_notice1'), () => {
            this.$router.push({
              path: '/user/edit'
            })
          })
        }
      }
      if (code === 'CreditCard' && this.creditCard.credit_card_number.length === 0 && this.selectedPayment.code !== 'HeroPay') {
        showNotice(this.$t('Bao.credit_card_notice'), () => {
          this.$router.push({
            path: '/user/bank/create',
            query: { selectType: 4 }
          })
        })
      }
    },
    isSelectedPayment(payment) {
      return this.selectedPayment && this.selectedPayment.payment_id === payment.payment_id
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    handleRecheckFortype3(payment_id) {
      this.postForm.payment_id = payment_id
      this.fetchRealtimeCryptoRate(payment_id)
    },
    handleRecheck(payment_id) {
      this.postForm.payment_id = payment_id
      this.fetchCurrentRate(payment_id)
    },
    resetTimer() {
      clearInterval(this.timer)
      this.timeLeft = 0
    },
    closeCVV() {
      this.showCVV = false
    },
    fetchCurrentRate(payment_id) {
      checkDepositRate(payment_id)
        .then(response => {
          if (response.data.data === null) {
            showNotice(this.$t('Bao.crypto_fail'))
          } else {
            const matchCurrency = this.types.find(type => type.payment_id === payment_id)
            let newRate = response.data.data[matchCurrency.typeCode]
            if (matchCurrency.typeCode === 'JetonCash') {
              this.selectedCrypto = matchCurrency
              newRate = response.data.data['EUR']
            }
            matchCurrency.deposit_rate = newRate
            this.postForm.amount = this.cryptoAmount
          }
        }).then(() => {
          this.timeLeft = 300
          this.startCountdown()
        })
    },
    fetchRealtimeCryptoRate(payment_id) {
      checkDepositCryptoRate(payment_id)
        .then(response => {
          if (response.data.data === null) {
            showNotice(this.$t('Bao.crypto_fail'))
          } else {
            // const matchCurrency = this.types.find(type => type.payment_id === payment_id)
            const newRate = response.data.data.deposit_rate
            // if (matchCurrency.typeCode === 'JetonCash') {
            //   this.selectedCrypto = matchCurrency.typeName
            //   newRate = response.data.data['EUR']
            // }
            this.selectedCrypto.deposit_rate = newRate
            this.postForm.amount = this.cryptoAmount
          }
        }).then(() => {
          this.timeLeft = 300
          this.startCountdown()
        })
    },
    handleCryptoSelection() {
      if (this.selectedCrypto) {
        this.postForm.payment_id = this.selectedCrypto.payment_id
      }
    },
    formatCryptoAmount() {
      const num = Number(this.cryptoAmount)
      const decimalPlaces = (num.toString().split('.')[1] || '').length
      return decimalPlaces > 8 ? num.toFixed(8) : num.toFixed(decimalPlaces)
    },
    showDepositText() {
    // 獎勵充值下限
      this.todayArr.forEach(item => {
        if (item.condition_value_2 === this.count + 1) {
          this.bounsLowerLimit = item.condition_value_3
        }
      })
      if (this.selectedEvent && this.selectedEvent.type === 'daily_multiple_deposit' &&
          this.selectedPayment && this.postForm.amount < this.bounsLowerLimit) {
        return true
      }
      return false
    },
    isUnopenedEvent(item) {
      const type = item.type
      if (type === 'manual_first_deposit_v2' && this.memberInfo.first_deposit_amount !== 0) return true
      if (type === 'manual_first_deposit' && this.memberInfo.first_deposit_amount !== 0) return true
      if (type === 'manual_second_deposit' && this.memberInfo.second_deposit_amount !== 0) return true
      if (type === 'manual_third_deposit' && this.memberInfo.third_deposit_amount !== 0) return true

      if (type === 'daily_multiple_deposit' && this.multipleDeposit.length !== 0) {
        if (this.count >= this.activityCount) {
          return true
        }
      }
      return false
    },
    handleEvent(item) {
      if (this.isUnopenedEvent(item)) {
        item.select = false
        this.selectedEvent = null
        return
      } else if (this.selectedEvent && this.selectedEvent.id === item.id) {
        // If the same event is clicked again, toggle select
        item.select = !item.select
        if (item.select) {
          this.checkQualification(item)
        }
      } else {
        // If a different event is clicked, select it and deselect the previous one
        if (this.selectedEvent) {
          this.selectedEvent.select = false
        }
        item.select = true
        this.checkQualification(item)
      }

      setTimeout(() => {
        this.selectedEvent = item.select ? item : null
        this.$store.dispatch('selectEvent', item.id)
      }, 0.5)

      if (item.type === 'daily_multiple_deposit') {
        this.postForm.join_event_info = JSON.stringify([{ 'type': 'daily_multiple_deposit' }])
        this.showDepositText()
      } else {
        this.postForm.join_event_info = JSON.stringify([{ 'type': item.type }])
      }

      if (this.selectedEvent && this.selectedEvent.id === this.deposit_v2) {
        this.postForm.event_type = 'deposit_v2'
        this.postForm.event_join = true
      }
    },
    getTransactions() {
      var today = new Date()
      today.setHours(0, 0, 0, 0)
      var midnightTimestamp = today.getTime()
      var timestampInSeconds = Math.floor(midnightTimestamp / 1000)
      var currentTime = Math.floor(Date.now() / 1000)

      DepositTransactions({ start_at: timestampInSeconds, end_at: currentTime }).then(response => {
        response.data.data.list.forEach(item => {
        // 到帳次數（扣除首存、二存、三存、特規首存）
          if (item.setting === null) {
            this.count++
          } else if (item.setting !== null && item.setting.event) {
            item.setting.event.forEach(event => {
              if (event.type !== 'manual_first_deposit' && event.type !== 'manual_second_deposit' &&
                  event.type !== 'manual_third_deposit' && event.type !== 'custom_first_deposit') {
                this.count++
              }
            })
          }
        })
      })
    },
    handleAmount(amount) {
      this.postForm.amount = amount
      this.selectedAmount = amount

      const getPercentMap = (length) => {
        switch (length) {
          case 3:
            return {
              [this.selectedPayment.price_list[1]]: 48,
              [this.selectedPayment.price_list[2]]: 98
            }
          case 4:
            return {
              [this.selectedPayment.price_list[1]]: 33,
              [this.selectedPayment.price_list[2]]: 66.05,
              [this.selectedPayment.price_list[3]]: 98.5
            }
          case 5:
            return {
              [this.selectedPayment.price_list[1]]: 24.5,
              [this.selectedPayment.price_list[2]]: 49,
              [this.selectedPayment.price_list[3]]: 74,
              [this.selectedPayment.price_list[4]]: 98.5
            }
          default:
            return {}
        }
      }
      const percentMap = getPercentMap(this.selectedPayment.price_list.length)
      this.percent = percentMap[amount] || 0
      this.cryptoAmount = ''
    },
    calculateBonus() {
      if (this.postForm.amount === '' || isNaN(this.postForm.amount)) return
      const amount = (this.selectedCrypto !== null || this.selectedTypeCode === 'JetonCash') ? this.postForm.amount : parseInt(this.postForm.amount)
      if (this.selectedEvent === null) {
        this.eventBonus = 0
        return
      }

      // deposit_v2: 每日存款活動
      if (this.selectedEvent.type === 'deposit_v2') {
        this.eventBonus = 0
        this.selectedEvent.setting.forEach(item => {
          if (amount <= item.max_deposit_amount && amount >= item.min_deposit_amount) {
            const prize = amount * (item.prize / 100)
            this.eventBonus = parseFloat(prize)
          }
        })
      } else {
        // 加密貨幣 & JetonCash要做換算
        const newAmout = (this.selectedCrypto !== null || this.selectedTypeCode === 'JetonCash') ? amount * this.currencyRate.deposit_rate : amount
        // 活動最低存款金額：condition_value
        if (newAmout < this.selectedEvent.setting[0].condition_value) {
          this.eventBonus = 0
          return
        }
        const conditionValue = parseFloat(this.selectedEvent.setting[0].condition_value_2)
        const bonus = !isNaN(conditionValue) ? amount * (conditionValue / 100) : 0
        // 活動單筆最大獎金上限：condition_value_3
        // 加密貨幣 & JetonCash要做換算
        const cryptoBonus = (this.selectedCrypto !== null || this.selectedTypeCode === 'JetonCash') ? bonus * this.currencyRate.deposit_rate : bonus
        this.eventBonus = cryptoBonus > this.selectedEvent.setting[0].condition_value_3 ? this.selectedEvent.setting[0].condition_value_3 : cryptoBonus
      }
    },
    calculateTotalBonus() {
      if (this.postForm.amount === '') {
        return this.eventBonus
      } else if (this.selectedCrypto) {
        return parseFloat(this.currencyRate.currencyRate) + this.eventBonus
      } else {
        return parseInt(this.postForm.amount) + this.eventBonus
      }
    },
    checkQualification(event) {
      getEventQualification(event.type)
        .then(response => {
          const code = response.data.data.code
          this.handleResponseCode(code)
          if (event.type === 'manual_first_deposit_v2') {
            showNotice(this.depositEventRule, null, true, false, '同意する')
          }
        })
        .catch(error => {
          showNotice(error.response.data.msg)
        })
    },
    handleResponseCode(code) {
      this.checkQual = false
      switch (code) {
        case 1001:
          this.lastResponseMessage = 'Bao.special_deposit_err6'
          break
        case 2001:
        case 3001: {
          this.lastResponseMessage = 'Bao.unavailible_4'
          break
        }
        case 2101:
          this.lastResponseMessage = 'Bao.member_type_not_pass'
          break
        case 5101:
          this.lastResponseMessage = 'Bao.first_deposit_exist'
          break
        case 5102:
          this.lastResponseMessage = 'Bao.first_deposit_not_enough'
          break
        case 5201:
          this.lastResponseMessage = 'Bao.second_deposit_exist'
          break
        case 5202:
          this.lastResponseMessage = 'Bao.second_deposit_not_enough'
          break
        case 5301:
          this.lastResponseMessage = 'Bao.third_deposit_exist'
          break
        case 5302:
          this.lastResponseMessage = 'third_deposit_not_exist'
          break
        default:
          this.checkQual = true
          this.lastResponseMessage = ''
          return
      }

      showNotice(this.$t(this.lastResponseMessage))
    },
    checkIsDeposit() {
      if (this.first_deposit_at === 0 && this.before_withdrawal_module_setting !== null) {
        this.showModel = true
      } else {
        this.handleSubmit()
      }
    },
    handleSubmit() {
      this.showModel = false
      if (!this.checkQual) {
        if (this.lastResponseMessage) {
          showNotice(this.$t(this.lastResponseMessage))
        }
        return
      }
      const self = this
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (this.selectedPayment.id === 'manual') {
            console.log('manual')
          } else {
            if (this.selectedEvent && this.selectedEvent.type !== 'daily_multiple_deposit') {
              joinEvent(this.selectedEvent.id)
                .then(() => {})
                .catch((error) => {
                  showNotice(error.response.data.msg)
                })
            }
          }
        }
      })

      if (this.selectedPayment.name !== 'VegaWallet') {
        var newWindow = window.open('/loading.html', '_blank')
      }

      let encryptedPostForm = { ...this.postForm }

      // 如果支付方式為 'VegaWallet',則加密密碼
      if (this.selectedPayment.name === 'VegaWallet') {
        encryptedPostForm.other = { ...this.other }
        encryptedPostForm.other.password = crypto.MD5(encryptedPostForm.other.password).toString()
      } else if (this.selectedPayment.name === 'JetonPay') {
        encryptedPostForm.other = { ...this.other }
      } else if (this.selectedPayment.typeCode === 'JetonCash') {
        encryptedPostForm = {
          ...encryptedPostForm,
          ...this.Jcash
        }
      } else if (this.selectedPayment.typeCode === 'CreditCard' && this.selectedPayment.code !== 'HeroPay') {
        encryptedPostForm = {
          ...encryptedPostForm,
          ...this.creditCard,
          cvv2: this.creditCard.securityCode,
          credit_card_number: this.selectedCreditCard.credit_card_number,
          member_creditcard_id: this.selectedCreditCard.id
        }
      } else {
        // 其他支付方式,不需要帳號密碼
        delete encryptedPostForm.other
      }

      const encryptedOtherString = JSON.stringify(encryptedPostForm.other)

      // This ensures DepositPayment is always triggered, regardless of validation result
      DepositPayment({ ...encryptedPostForm, other: encryptedOtherString })
        .then((response) => {
          const result = response.data.data

          this.url = result.content
          if (this.selectedPayment.name === 'VegaWallet' || this.selectedPayment.typeCode === 'JetonCash') {
            showNotice(
              this.$t('Bao.deposit_processing_notice_1') + '<br>' + this.$t('Bao.deposit_processing_notice_2'),
              function() {
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              }
            )
            return
          }

          if (newWindow !== undefined) {
            newWindow.location = this.url
            showNotice(
              this.depositConfirmMessage,
              function() {
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              }
            )

            // 偵測新視窗是否關閉
            var startCheck = false
            self.listenTimer = window.setInterval(function() {
              try {
                var newHost = newWindow.location.host
              } catch (e) {
                newHost = 'cross domain'
              }

              console.log('detect..', newHost, startCheck)
              if (newHost !== window.location.host) {
                startCheck = true
              }

              if (newHost === window.location.host && startCheck) {
                newWindow.close()
                window.clearInterval(self.listenTimer)
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              } else if (newWindow.closed) {
                window.clearInterval(self.listenTimer)
                self.$router
                  .push({ path: '/user/deposit-record' })
                  .catch(() => {
                  })
              }
            }, 1000)
          } else {
          // app不另開視窗
            window.location = this.url
          }
        })
        .catch((error) => {
          setErrorMessage(error.response, this.errors)

          if (newWindow !== undefined) {
            newWindow.close()
          }
        })
    },
    validateNumber(event) {
      if (this.selectedPayment.typeNum === 3 || this.selectedPayment.typeCode === 'JetonCash') {
        // Allow only numbers
        event.target.value = event.target.value.replace(/[^\d.]/g, '')
        this.cryptoAmount = event.target.value
        this.postForm.amount = this.cryptoAmount
      } else {
        // Only allow integers
        event.target.value = event.target.value.replace(/[^0-9]/g, '')
        this.postForm.amount = event.target.value
        this.cryptoAmount = ''
      }
    },
    getDayNumber() {
      const currentDate = new Date()
      let dayNumber = currentDate.getDay() // Sunday - 0, Monday - 1, ..., Saturday - 6
      if (dayNumber === 0) {
        dayNumber = 7 // Change Sunday from 0 to 7
      }
      return dayNumber % 7 // Modulo 7 will turn 7 (Sunday) into 0
    },
    hideModel() {
      this.showModel = false
    },
    handlePromoClick(event) {
      const clickedElement = event.target
      const slideElement = clickedElement.closest('.promotionCards')

      if (!slideElement) return
      if (slideElement.classList.contains('unopened-event')) return

      if (clickedElement.classList.contains('proCheckBox') || clickedElement.tagName === 'IMG') {
        const index = slideElement.dataset.eventIndex
        const item = this.sortedEvents[index]
        if (item) {
          // 移除所有活動卡片的 active class
          document.querySelectorAll('.promotionCards').forEach(card => {
            card.classList.remove('active')
          })

          this.handleEvent(item)

          if (item.select) {
            slideElement.classList.add('active')
          }
        }
      }
    },
    isMobile() {
      return detectMob()
    }
  }
}
</script>

<style>
.blue-link {
  color: #007aff;
  cursor: pointer;
}

.locked-input {
  background-color: #CECECE !important;
  cursor: not-allowed;
  color:#898989 !important;
}

.swiper-button-prev.pro-arrow,
.swiper-button-next.pro-arrow {
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #978564;
	color: #fff;
	cursor: pointer;
	border-radius: 100%;
}

.swiper-pagination.swiper-pagination-fraction {
  bottom: 5px;
  width: 30%;
  left: 35%;
}

.swiper-button-prev, .swiper-button-next {
  top: 98%;
}

.swiper-button-next {
  right: 40%;
}

.swiper-button-prev {
  left: 40%;
}

.swiper-button-prev:after, .swiper-button-next:after{
  font-size: 10px;
}

.crypto-type {
  white-space: nowrap;
}

@media (max-width: 992px) {
  .swiper-button-next {
    right: 33%;
  }

  .swiper-button-prev {
    left: 33%;
  }
}

.popup-success.deposit button.button-style-5 {
  margin: 10px;
}
</style>
